<template>
    <div style="height: 100vh;" class="p-4">
        <iframe :src="href" frameborder="0" width="100%" height="100%" id="print-iframe"></iframe>
    </div>
</template>
<script>
export default {
    props: {
        print: {
            type: Boolean,
            default: true
        }
    },
    data(){
        return{ 
            href: '',
            id: this.$route.params.id,
        }
    },
    created() {
        let vue = this
        axios({url: '/thinning/packages/' + vue.id + '/print?print='+ vue.print, method: 'GET', responseType: 'blob' })
        .then((response) => {
            vue.href = window.URL.createObjectURL(response.data)
        })
        .catch((err) => {
            if(err.response.status === 422 || err.response.status === 402 || err.response.status === 404){
               let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
            }else{
                vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
            }
        })
    }
}
</script>